export default __webpack_public_path__ + "static/media/cabinetdoormiddle.2ca15d89.jpg";